import { render, staticRenderFns } from "./SupportDeskRedirect.vue?vue&type=template&id=181e9997&scoped=true"
import script from "./SupportDeskRedirect.vue?vue&type=script&lang=js"
export * from "./SupportDeskRedirect.vue?vue&type=script&lang=js"
import style0 from "./SupportDeskRedirect.vue?vue&type=style&index=0&id=181e9997&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181e9997",
  null
  
)

export default component.exports